import { InstructorDetail } from "@features/instructor/types";
import SectionHeader from "./SectionHeader";
import InstructorDescriptionLayout from "./InstructorDescriptionLayout";
import InstructorDegreeLayout from "./InstructorDegreeLayout";
import DocumentPaper3Lines from "@svg/new-design/document-paper-3-lines";
import Graduated from "@svg/new-design/graduated";
import UserInformation from "@svg/new-design/user-information";
import BoardTaskIcon from "@svg/new-design/exam";
import { FC, ReactNode } from "react";

interface Props {
  instructor: InstructorDetail;
  parsedBio: ReactNode;
}

const InstructorDesktopSidebar: FC<Props> = ({ instructor, parsedBio }) => {
  const hasDegrees = instructor.instructor_educational_background.length > 0;

  return (
    <div className="w-full fds-l:block hidden border border-fds-cart rounded-8 h-max ">
      <div className="pt-6  px-4     pb-6  ">
        <SectionHeader
          icon={UserInformation}
          title={`درباره ${instructor.name}`}
        />
        <InstructorDescriptionLayout description={parsedBio} />
      </div>

      {hasDegrees ? (
        <div className="px-4     pt-6  pb-8   border-t border-fds-default">
          <SectionHeader
            icon={Graduated}
            title="سوابق تحصیلی"
            iconClassName="text-fds-tertiary w-6  h-6"
          />
          <InstructorDegreeLayout
            degrees={instructor.instructor_educational_background}
          />
        </div>
      ) : null}

      {instructor.instructor_research_fields ? (
        <div className="pt-6  px-4     pb-6  border-t border-fds-default">
          <SectionHeader
            icon={DocumentPaper3Lines}
            title="زمینه های پژوهشی و آموزشی"
            iconClassName="text-fds-tertiary w-6  h-6"
          />
          <InstructorDescriptionLayout
            description={instructor.instructor_research_fields}
          />
        </div>
      ) : null}

      {instructor.instructor_skills ? (
        <div className="pt-6  px-4     pb-6  border-t border-fds-default">
          <SectionHeader icon={BoardTaskIcon} title="مهارت ها" />
          <InstructorDescriptionLayout
            description={instructor.instructor_skills}
          />
        </div>
      ) : null}
    </div>
  );
};

export default InstructorDesktopSidebar;
